/**
 * Canonical SMS message templates and defaults.
 * Keep this as the single source of truth for SMS node message seeding.
 */
export const SMS_MESSAGE_TYPES = [
  'Missed call',
  'Incoming call',
  'Voicemail',
  'Custom',
] as const

export const SMS_MESSAGE_TEMPLATES: Record<string, string> = {
  'Missed call': 'Missed call from {CALLER_ID}-{CALLER_NUMBER}',
  'Incoming call': 'Incoming call from {CALLER_ID}-{CALLER_NUMBER}',
  Voicemail: '{CALLER_ID}-{CALLER_NUMBER} went to Voicemail',
  // Custom intentionally uses an empty sentinel; callers branch on "Custom"
  // and should not auto-apply a template in that state.
  Custom: '',
}

export const DEFAULT_SMS_MESSAGE_TYPE = 'Missed call'
export const DEFAULT_SMS_MESSAGE_TEMPLATE =
  SMS_MESSAGE_TEMPLATES[DEFAULT_SMS_MESSAGE_TYPE]

/**
 * Resolve the canonical template for pre-configured SMS message types.
 * Returns undefined for Custom/unknown message types.
 */
export const getSmsTemplateForMessageType = (
  messageType?: string,
): string | undefined => {
  if (!messageType || messageType === 'Custom') {
    return undefined
  }

  const template = SMS_MESSAGE_TEMPLATES[messageType]
  return template || undefined
}
